@if (premiumQuestions) {
  <form novalidate [formGroup]="premiumLeadForm" (ngSubmit)="submitForm(premiumLeadForm.value)">
    @for (key of premiumQuestionKeys; track key; let i = $index) {
      <div class="field">
        @if (! premiumQuestions[key]['hidden']) {
          <div class="wrapper is-flex-tablet is-block-mobile">
            <label class="label">
              <span class="icon">
                <i [class]="premiumQuestions[key]['icon']"></i>
              </span>
              {{ premiumQuestions[key]['text'] }}
            </label>
            <div class="control buttons is-block">
              @for (button of premiumQuestions[key]['buttons']; track button) {
                <button
                  type="button"
                  class="button has-shadow-small"
                  [ngClass]="[premiumLeadControls[key]['value'] === button.text ? 'is-success' : 'is-light']"
                  (click)="submitControl(key, button.text)"
                  >
                  <span class="icon">
                    <i [class]="button.text === 'Yes' || button.text === 'Other' ? 'far fa-check-circle' : 'far fa-times-circle'"></i>
                  </span>
                  {{ button.text }}
                </button>
              }
              <input type="hidden" [formControlName]="key" [value]="premiumLeadControls[key]['value']">
              @if (invalidSubmission && premiumLeadControls[key]['value'] === '' && premiumLeadControls[key].errors?.required) {
                <p class="help is-danger">
                  An answer is required for this question.
                </p>
              }
            </div>
          </div>
        }
      </div>
    }
    <div class="field">
      <div class="control">
        <button type="submit" class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large" [disabled]="! premiumLeadForm.valid || disableSubmit">View Your Rates &#12297;</button>
      </div>
    </div>
    <div class="field">
      <p class="tcpa is-size-7 has-text-grey-dark">
        <input type="hidden" id="tcpa_disclosure">
        <label for="tcpa_disclosure">
          *By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC and its <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer">network of lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.
          <br/><br/>
          I also agree to and am electronically signing FreeRateUpdate.com's <a href="/privacy" target="_blank" rel="nofollow noopener noreferrer">Privacy Policy</a> and its <a href="/terms" rel="nofollow noopener noreferrer" target="_blank">Terms and Conditions</a>.
        </label>
      </p>
      <p class="is-flex is-flex-centered">
        <img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
      </p>
    </div>
  </form>
}

@if (invalidSubmission) {
  <article class="message is-danger">
    <div class="message-header">
      <p>{{ responseErrors.status || 'error' }}</p>
      <button class="delete" aria-label="delete"></button>
    </div>
    <div class="message-body">
      {{ responseErrors.message || 'Invalid submission.' }}
    </div>
  </article>
}
